import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import LiveMatches from './components/LiveMatches';
import HotSchedule from './components/HotSchedule';
import LatestNews from './components/LatestNews';

export default function Home() {
  return (
    <main>
      <HeroBanner />
      <CategoryNav />
      <LiveMatches />
      <HotSchedule />
      <LatestNews />
    </main>
  );
}